<template>
    <div>
        <el-dialog :visible.sync="visible" :title="title" @close="closeDialog">
            <div>
                <el-date-picker 
                    v-model="selectedDate" 
                    :type="pickerType" 
                    :format="dateFormat"
                    :value-format="valueFormat"
                    :default-value="defaultDate"
                    :picker-options="pickerOptions"
                    @change="onDateChange"
                    ></el-date-picker>
            </div>
            <div slot="footer">
                <el-button @click="closeDialog">取消</el-button>
                <el-button @click="confirmDate" type="primary">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'DatePicker',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Select Date'
        },
        defaultDate: {
            type: Date,
            default: () => new Date()
        },
        dateFormat: {
            type: String,
            default: 'yyyy-MM-dd'
        },
        valueFormat: {
            type: String,
            default: 'yyyy-MM-dd'
        },
        minDate: {
            type: Date,
            default: () => new Date('2000-01-01')
        },
        maxDate: {
            type: Date,
            default: () => new Date('2100-12-31')
        },
        type: {
            type: String,
            default: 'date',
            validator: value => ['date', 'week', 'month'].includes(value)
        }
    },
data() {
    return {
        localVisible: this.visible, // 本地属性
        selectedDate: this.defaultDate,
        pickerOptions: {
            disabledDate: (date) => {
                // 仅在类型为 'date' 时禁用小于 minDate 和大于 maxDate 的日期
                if (this.type === 'date') {
                    return date < this.minDate || date > this.maxDate;
                }
                return false; // 其他类型不禁用任何日期
            }
        }
    };
},
watch: {
    visible(newVal) {
        this.localVisible = newVal; // 当父组件的visible变化时，更新本地属性
    }
},
computed: {
    pickerType() {
        return this.type; 
    },
    computedMinDate() {
        return this.type === 'date' ? this.minDate : null;
    },
    computedMaxDate() {
        return this.type === 'date' ? this.maxDate : null;
    }
    

},
methods: {
    closeDialog() {
        this.localVisible = false; // 关闭对话框时更新本地属性
        this.$emit('close');
    },
    confirmDate() {
        this.$emit('confirm', this.selectedDate);
        this.closeDialog();
    },
    onDateChange(date) {
        console.log('Date changed:', date);
        this.selectedDate = date;
        this.$emit('dateChanged', date);
    }
}
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    padding: 0; 
    padding-left: 20px !important;
    padding-top: 20px !important;
}
</style>